/**
 * PieChartOverview Widget - Eigenständige Version für das neue Widget-System
 * Zeigt nur das Donut-Diagramm an
 */
import DonutChart from './DonutChart';
import './PieChartOverview.scss';

const PieChartOverview = () => {
  // Farbdefinitionen
  const color = {
    red: '#DC2626',
    yellow: '#FBBF24',
    green: '#a3e635'
  };

  return (
    <div className="pie-chart-overview-widget">
      <div className="row">
        <div className="col-md-12">
          <div className="widget-piechart">
            <DonutChart color={color} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PieChartOverview;
